import React from 'react'
import { Title as UiTitle, ThemeProvider } from '@deseretbook/react-ui'

/**
 * Wrapper for the react-ui Title component. Useful when you need a standalone title.
 *
 * @param {object} props - Props for Title component
 * @returns {function} - Title Component
 */
const Title = props => (
  <ThemeProvider>
    <UiTitle {...props} />
  </ThemeProvider>
)


export default Title
